(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halo-editorial-hero"] && !Shopify.designMode) return;
  try {
    
function setupHaloVideos(root) {
  root.querySelectorAll('.halo-editorial-hero__video').forEach(video => {
    if (video.dataset.haloReady) return;
    video.dataset.haloReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      if (motion.matches) video.pause();
      else video.play().catch(() => {});
    };
    video.muted = true;
    motion.addEventListener('change', sync);
    sync();
  });
}
setupHaloVideos(document);
document.addEventListener('shopify:section:load', event => setupHaloVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
